import React, {useState} from 'react';
import {slide as Menu} from 'react-burger-menu';
import {BurgerMenu, MaxisBusinessLogoMobile, CrossMenu, SearchIconBlack, LoginLogo, CartIcon} from '../../../styles/icons';
import Label from '../../Label';
import {headerUrl} from '../Header.Config';
import { pagePath } from '../../../RouteConfig';

export default function SideBar({
    intl,
    headerDetails,
    topHeaderRightGroup,
    topHeaderLeftGroup,
    selectionOption,
    onClickTopHeader,
    onSearchClick,
    showSolrSearch
}) {
    const [isSideBarOpen, setSideBarOpen] = useState(false);

    const handleIsOpen = () => {
        setSideBarOpen(!isSideBarOpen);
    };

    const onMenuSearch = () => {
        onSearchClick();
        handleIsOpen();
    };
    return (
        <div className='bottom-header'>
            <div className='container'>
                <div className='row align-items-center bottom-header'>
                    <div className='d-flex flex-row col-6 gap-20px'>
                        <Menu
                            isOpen={isSideBarOpen}
                            onOpen={handleIsOpen}
                            onClose={handleIsOpen}
                            customBurgerIcon={<BurgerMenu />}
                            customCrossIcon={<CrossMenu />}
                        >
                            <div className='d-flex flex-wrap align-items-center mt-2'>
                                {selectionOption.map((option, index) => {
                                    return (
                                        <Label
                                            key={`${index}_${option.label}`}
                                            labelClass={`text-center ${option.mobileStyle} me-2 py-1`}
                                            labelData={option.label}
                                            clickEvent={() => onClickTopHeader(option.url)}
                                        />
                                    );
                                })}
                            </div>
                            {(headerDetails || []).map((item, index) => {
                                return (
                                    <div
                                        className={`fs-18 pt-1 maxis-bold ${item.style}`}
                                        onClick={handleIsOpen}
                                        key={`${index}_${item.title}`}
                                    >
                                        {item.title}
                                    </div>
                                );
                            })}
                            <hr className='container line-green-mobile'></hr>
                            <div>
                                {topHeaderRightGroup.map((group, index) => {
                                    return (
                                        <div
                                            className='py-2 maxis-bold text-dark-blue-2 fs-18'
                                            onClick={() => onClickTopHeader(group.url)}
                                            key={`${index}_${group.text}`}
                                        >
                                            <span className='me-2'>{group.logo}</span>
                                            {group.text}
                                        </div>
                                    );
                                })}
                            </div>
                            {showSolrSearch && (
                                <div onClick={onMenuSearch}>
                                    <SearchIconBlack />
                                    <span className='maxis-bold text-black-two fs-18'>{intl.messages.searchLabel}</span>
                                </div>
                            )}
                            <hr className='container line-green-mobile'></hr>
                            <div className='d-flex flex-row'>
                                {topHeaderLeftGroup.map((group, index) => {
                                    return (
                                        <div
                                            className={`py-2 me-4 ${group.style} maxis-bold fs-18`}
                                            onClick={() => window.open(group.url, '_blank')}
                                            key={`${index}_${group.text}`}
                                        >
                                            {group.text}
                                        </div>
                                    );
                                })}
                            </div>
                            <hr className='container line-grey-mobile maxis-bold'></hr>
                        </Menu>
                        <div className='' onClick={() => onClickTopHeader(pagePath.cart)}>
                            <CartIcon width={24} height={18} />
                        </div>
                        <div className='' onClick={() => onClickTopHeader(headerUrl.businessHubLink)}>
                            <LoginLogo width={24} height={18} />
                        </div>
                        {showSolrSearch && (
                            <div className='' onClick={() => onSearchClick()}>
                                <SearchIconBlack />
                            </div>
                        )}
                    </div>
                    <div className='d-flex flex-row justify-content-end col-6'>
                        <div>
                            <MaxisBusinessLogoMobile />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
